import { render, staticRenderFns } from "./CreateNonTransferableDialog.vue?vue&type=template&id=0a9246c6&"
import script from "./CreateNonTransferableDialog.vue?vue&type=script&lang=ts&"
export * from "./CreateNonTransferableDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports